module.exports = __webpack_public_path__ + "img/2.94a48c15.jpg";